import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Form, Container, Row, Col, Card } from "react-bootstrap";

const AddWallet = () => {
  // State to hold form data
  const [formData, setFormData] = useState({
    mobileNumber: "",
    month: "",
    year: "",
    amount: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-start align-items-start p-4"
      style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <Card
        className="shadow-lg"
        style={{
          width: "300px",
          backgroundColor: "#ffffff",
          borderRadius: "10px",
          border: "none",
        }}
      >
        <Card.Body>
          
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="formMobileNumber">
                  <Form.Label style={{ fontWeight: "500", color: "#555" }}>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter mobile number"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    className="border rounded-lg"
                    style={{ boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.2)" }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Group controlId="formAmount">
                  <Form.Label style={{ fontWeight: "500", color: "#555" }}>Amount</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter amount"
                    name="amount"
                    value={formData.amount}
                    onChange={handleInputChange}
                    required
                    className="border rounded-lg"
                    style={{ boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.2)" }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Group controlId="formMonth">
                  <Form.Label style={{ fontWeight: "500", color: "#555" }}>Month</Form.Label>
                  <Form.Control
                    as="select"
                    name="month"
                    value={formData.month}
                    onChange={handleInputChange}
                    required
                    className="border rounded-lg"
                    style={{ boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.2)" }}
                  >
                    <option value="">Select Month</option>
                    <option value="January">January</option>
                    <option value="February">February</option>
                    <option value="March">March</option>
                    <option value="April">April</option>
                    <option value="May">May</option>
                    <option value="June">June</option>
                    <option value="July">July</option>
                    <option value="August">August</option>
                    <option value="September">September</option>
                    <option value="October">October</option>
                    <option value="November">November</option>
                    <option value="December">December</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="formYear">
                  <Form.Label style={{ fontWeight: "500", color: "#555" }}>Year</Form.Label>
                  <Form.Control
                    as="select"
                    name="year"
                    value={formData.year}
                    onChange={handleInputChange}
                    required
                    className="border rounded-lg"
                    style={{ boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.2)" }}
                  >
                    <option value="">Select Year</option>
                    {[...Array(10)].map((_, index) => {
                      const year = new Date().getFullYear() + index;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Button
  variant="primary"
  type="submit"
  className="rounded-lg"
  style={{
    backgroundColor: "#007bff",
    border: "none",
    fontWeight: "500",
    fontSize: "14px", // Smaller font size
    width: "30%", // Reduced button width
    padding: "8px", // Smaller padding
    transition: "background-color 0.3s",
    margin: "0 auto", // Center the button
    display: "block", // Ensures proper centering
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
  onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
>
  Submit
</Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AddWallet;
